// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Manual Fixes for Standalone Build Layout --- */

/* 1. Favorites Box Width Fix */
.favorite-header-box {
    position: relative;
    width: 54px !important;
    min-width: 54px !important;
    flex-shrink: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
    background-color: #f8f9fa;
    border-right: 1px solid #e5e7eb;
    overflow-y: auto;
    z-index: 20;
}

html.dark .favorite-header-box {
    background-color: #1f2937;
    border-right-color: #374151;
}

/* 2. Header Menu Wrapping Fix */
.header-menu-nowrap {
    white-space: nowrap !important;
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    min-width: max-content !important;
}

.header-action-start {
    min-width: max-content !important;
    flex-shrink: 0 !important;
}

/* 3. Logo Visibility Fix (스탠드얼론: 30% 크기 증가) */
.header-logo-visible {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-end !important;
    justify-content: center !important;
    height: 72px !important;
    min-width: 156px !important;
    overflow: visible !important;
}

/* 4. Canvas Height Propagation Fix */
html,
body,
#root,
.app-layout-modern {
    height: 100% !important;
    overflow: hidden !important;
}

.page-container-wrapper-fix {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
    overflow: hidden;
}

/* Force React Flow parent to fill */
.react-flow-container-fix {
    width: 100%;
    height: 100% !important;
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/standalone-overrides.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,gCAAgC;AAChC;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA,8CAA8C;AAC9C;IACI,wBAAwB;IACxB,iCAAiC;IACjC,gCAAgC;IAChC,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,qCAAqC;AACrC;;;;IAII,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":["/* --- Manual Fixes for Standalone Build Layout --- */\r\n\r\n/* 1. Favorites Box Width Fix */\r\n.favorite-header-box {\r\n    position: relative;\r\n    width: 54px !important;\r\n    min-width: 54px !important;\r\n    flex-shrink: 0 !important;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 8px 0;\r\n    background-color: #f8f9fa;\r\n    border-right: 1px solid #e5e7eb;\r\n    overflow-y: auto;\r\n    z-index: 20;\r\n}\r\n\r\nhtml.dark .favorite-header-box {\r\n    background-color: #1f2937;\r\n    border-right-color: #374151;\r\n}\r\n\r\n/* 2. Header Menu Wrapping Fix */\r\n.header-menu-nowrap {\r\n    white-space: nowrap !important;\r\n    display: flex !important;\r\n    flex-wrap: nowrap !important;\r\n    align-items: center !important;\r\n    min-width: max-content !important;\r\n}\r\n\r\n.header-action-start {\r\n    min-width: max-content !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n/* 3. Logo Visibility Fix (스탠드얼론: 30% 크기 증가) */\r\n.header-logo-visible {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: flex-end !important;\r\n    justify-content: center !important;\r\n    height: 72px !important;\r\n    min-width: 156px !important;\r\n    overflow: visible !important;\r\n}\r\n\r\n/* 4. Canvas Height Propagation Fix */\r\nhtml,\r\nbody,\r\n#root,\r\n.app-layout-modern {\r\n    height: 100% !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.page-container-wrapper-fix {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1 1 auto;\r\n    height: 100%;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Force React Flow parent to fill */\r\n.react-flow-container-fix {\r\n    width: 100%;\r\n    height: 100% !important;\r\n    min-height: 0;\r\n    flex: 1 1 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
